






























import { Component, Prop, Vue } from 'vue-property-decorator';
import Role from '@/models/Role';
import UserService from '@/services/UserService';

@Component
export default class RoleEdit extends Vue {
    @Prop() public id!: number;
    @Prop() public customerid!: number;

    private Model: Role ;
    private PageTitle: string = '';
    private Validated: boolean = false;

    constructor() {
        super();
        this.Model = new Role();
    }

    private async created() {
        this.PageTitle = `${this.id === 0 ? 'New' : 'Edit'} Role`;
        this.Model.CustomerId = this.customerid;

        if (this.id > 0) {
            this.LoadRole(this.id);
        } else {
            this.Model.Id = this.id;
        }
    }

    private async LoadRole(id: number) {
        const userService = new UserService();
        const response = await userService.LoadRole(id);
        if (response.Error === true) {
            this.$bvModal.msgBoxOk(`There was an error while trying to load the information`);
        } else {
            if (response.Data != null) {
                this.Model = response.Data;
            }
        }
    }

    private async SaveForm() {
        const userService = new UserService();

        let response: any;
        if (this.id === 0) {
            response = await userService.AddRole(this.Model);
        } else {
            response = await userService.UpdateRole(this.Model);
        }

        if (response.Error === true) {
            this.$bvModal.msgBoxOk(`There was an error while trying to save the information`);
        } else {
            this.$emit('changessaved', this.id > 0);
            this.$emit('editcancelled');
        }
    }

    private CancelSave() {
        this.$emit('editcancelled');
    }

    private PropertyState(propertyName: string) {
        if (!this.Validated) {
            return null;
        } else {
            const statusObj = this.Model.PropertyState(propertyName);
            if (statusObj) {
                return statusObj.Status;
            } else {
                return null;
            }
        }
    }

    private PropertyMessage(propertyName: string) {
        if (!this.Validated) {
            return '';
        } else {
            const statusObj = this.Model.PropertyState(propertyName);
            if (statusObj) {
                return statusObj.Message;
            } else {
                return null;
            }
        }
    }
}
